






















import { Component, Vue, Prop } from "vue-property-decorator";
import CModal from "@/basics/modal/CModal.vue";
import TextInput from "@/basics/inputs/TextInput.vue";
import CButton from "@/basics/buttons/CButton.vue";
import ModalTitle from "@/basics/modal/ModalTitle.vue";

@Component({
  components: { CModal, TextInput, CButton, ModalTitle },
  watch: {
    show() {
      (this as DeleteModal).reset();
    }
  }
})
export default class DeleteModal extends Vue {
  @Prop({ type: String, required: false, default: "名前" }) name!: string;
  @Prop({ type: Boolean, required: false, default: false }) show!: boolean;
  @Prop({ type: String, required: false, default: "" }) value!: string;
  @Prop({ type: String, required: false, default: "" }) message!: string;

  editingValue = "";
  status: null | "saving" | "saved" | "error" = null;
  error = "";

  reset() {
    this.editingValue = this.value;
    this.status = null;
  }

  close() {
    if (this.show) {
      this.$emit("close", { status: this.status });
    }
  }

  async save() {
    if (this.show) {
      try {
        this.status = "saving";
        await new Promise((resolve, reject) => {
          this.$emit("save", this.editingValue, resolve, reject);
        });
        this.status = "saved";
      } catch (e) {
        this.status = "error";
        this.error = "削除に失敗しました";
      }
    }
  }
}
